import * as React from "react";

interface AngleLeftIconProps {
    className?: string;
    onClick?: () => void;
    size?: string;
    fill?: string;
}

export class AngleLeftIcon extends React.Component<AngleLeftIconProps> {
    render(){
        return (
          <div {...this.props}>
            <svg width={this.props.size ?? "1em"} height={this.props.size ?? "1em"} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.98135 14.9367L18.4813 6.43672C19.0689 5.84922 20.0189 5.84922 20.6001 6.43672L22.0126 7.84922C22.6001 8.43672 22.6001 9.38672 22.0126 9.96797L15.9939 15.9992L22.0189 22.0242C22.6064 22.6117 22.6064 23.5617 22.0189 24.143L20.6063 25.5617C20.0189 26.1492 19.0689 26.1492 18.4876 25.5617L9.9876 17.0617C9.39385 16.4742 9.39385 15.5242 9.98135 14.9367Z" fill={this.props.fill ?? "#333333"}/>
                <path d="M9.98135 14.9367L18.4813 6.43672C19.0689 5.84922 20.0189 5.84922 20.6001 6.43672L22.0126 7.84922C22.6001 8.43672 22.6001 9.38672 22.0126 9.96797L15.9939 15.9992L22.0189 22.0242C22.6064 22.6117 22.6064 23.5617 22.0189 24.143L20.6063 25.5617C20.0189 26.1492 19.0689 26.1492 18.4876 25.5617L9.9876 17.0617C9.39385 16.4742 9.39385 15.5242 9.98135 14.9367Z" fill="white" fillOpacity="0.5"/>
            </svg>
           </div>
        );
    }
}
